import { promotionRoute } from './promotion';

export const allPromotion = [
  promotionRoute(),
];

